<template>

  <div>
    <div class="text-center">
      Access the projects you own
    </div>
    <div v-if="allLocalPortfolios.length !== 0">
      <div class="hpanel">
        <div class="panel-heading">
          <h3 class="text-center font-bold">Portfolios <span>({{portfolios.length}})</span></h3>
        </div>

      </div>

      <div class="row projects" v-for="(portfolio, key) in allLocalPortfolios" style="margin-bottom: 30px" v-bind:key="key">
        <div class="col-lg-12">
          <portfolio-list-row :portfolio="portfolio" v-model="refresh"/>
        </div>

      </div>

    </div>

    <div v-if="allLocalProjects.length !== 0">
      <div class="hpanel ">
        <div class="panel-heading">
          <h3 class="text-center font-bold">Unsorted Projects <span>({{allLocalProjects.length}})</span></h3>
        </div>
      </div>

      <div class="row projects" style="margin-bottom: 30px">
        <template v-for="(project, key) in allLocalProjects">
          <template v-if="key % 2 === 0">
            <div class="row"></div>
          </template>
          <project-item :key="key" class="col-md-6 col-sm-12" :project="project" v-model="refresh" :id="key === 0 ? 'projects-first_project' : ''"/>

        </template>
      </div>
    </div>
  </div>
</template>

<style>
  #dLabel1, #dLabel2{color: #fff;
    background-color: #204d74;
    border-color: #122b40}
  .m-t-md {
    margin-top: 22px;
  }
</style>

<script>
import PortfolioListRow from '../../components/project/PortfolioListRow'
import ProjectItem from '../../components/project/ProjectItem'
import ActionModalPortfolio from './ActionModalPortfolio'

export default {
  components: {
    ActionModalPortfolio,
    ProjectItem,
    PortfolioListRow
  },
  props: ['projects', 'portfolios'],
  name: 'MyProjects',
  data () {
    return {
      refresh: null,
      allLocalProjects: [],
      allLocalPortfolios: []
    }
  },
  watch: {
    projects: function () {
      this.parse()
    },
    refresh: function (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    parse: function () {
      this.allLocalPortfolios = Object.assign([], this.portfolios)

      this.allLocalProjects = this.projects.filter((project) => {
        return project.owner_id === this.$auth.user().id
      })

      this.allLocalPortfolios.sort((portfolio1, portfolio2) => {
        return new Date(portfolio2.updated_at) - new Date(portfolio1.updated_at)
      })

      this.allLocalProjects.sort((project1, project2) => {
        return new Date(project2.updated_at) - new Date(project1.updated_at)
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/MyProjects.vue